import { useEffect, useLayoutEffect, useRef, ReactNode } from 'react';
import { useLoader } from '../../providers/loader-provider';

interface LoaderProps {
  children: ReactNode;
}

const Loader = ({ children }: LoaderProps): JSX.Element => {
  let circleCommonClasses = 'h-3.5 w-3.5 bg-secondary-300 rounded-full mr-2';
  const { isLoading } = useLoader();
  const loaderOverlayRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (isLoading) {
      loaderOverlayRef.current?.focus();
    }
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isLoading]);

  return (
    <>
      {isLoading ? (
        <>
          <div aria-busy="true" className="fixed top-0 left-0 w-screen h-screen bg-black z-100 opacity-60" />
          <div
            ref={loaderOverlayRef}
            className="fixed top-0 left-0 flex flex-col items-center justify-center w-screen h-screen opacity-100 z-100"
            role="dialog"
            aria-modal="true"
            aria-label="Loading"
            tabIndex={-1}
          >
            <div className="sr-only" aria-live="assertive">
              Loading
            </div>
            <div className="flex">
              <div className={`${circleCommonClasses} animate-pulse-0`}></div>
              <div className={`${circleCommonClasses} animate-pulse-0.5`}></div>
              <div className={`${circleCommonClasses} animate-pulse-1`}></div>
            </div>
          </div>
        </>
      ) : null}
      <div aria-hidden={isLoading ? 'true' : undefined}>{children}</div>
    </>
  );
};

export default Loader;
